import { z } from "zod";
import type { StorePageEditConflict } from "./types";

const contentSchema = z.object({
  blurb: z.string().nullable().optional(),
  cta_label: z.string().nullable().optional(),
  closing_line: z.string().nullable().optional(),
  play_beats: z
    .array(z.object({ title: z.string(), body: z.string() }))
    .nullable()
    .optional(),
  icon: z.string().nullable().optional(),
  hero_media: z
    .array(
      z.object({
        kind: z.enum(["image", "video_url"]),
        src: z.string(),
        poster: z.string().nullable().optional(),
        alt: z.string(),
        order: z.number(),
      }),
    )
    .optional(),
  show_live_replay: z.boolean(),
  links: z
    .array(
      z.object({
        label: z.string(),
        url: z.string(),
        kind: z
          .enum(["website", "discord", "github", "docs", "video", "other"])
          .nullable()
          .optional(),
      }),
    )
    .optional(),
});
const conflictSchema = z.object({
  type: z.literal("store_page_edit_conflict"),
  current_revision_id: z.string(),
  current_content: contentSchema,
});

export function isStorePageEditConflict(
  value: unknown,
): value is StorePageEditConflict {
  return conflictSchema.safeParse(value).success;
}
